/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useCallback } from 'react';

import { ModalsMap } from './modalsMap';
import { ModalsMapType } from './types';
import { useModalContext } from './useModalContext';

const ModalRenderer = () => {
  const { currentModals, closeModal, openModal, replaceModal } = useModalContext();

  const handleClose = useCallback(
    async (count?: number, preClose?: () => void) => {
      try {
        await preClose?.();
      } catch (e) {
        closeModal(count);
      } finally {
        closeModal(count);
      }
    },
    [closeModal]
  );

  const modals = useMemo(
    () =>
      currentModals.map((modal) => {
        const CurrentModalComponent = currentModals ? ModalsMap[modal?.type as keyof ModalsMapType] : null;

        if (!CurrentModalComponent) return <div />;

        return (
          <CurrentModalComponent
            {...modal?.state}
            key={modal.type}
            open
            close={(count?: number) => handleClose(count, modal?.state?.preClose)}
            openModal={openModal}
            replaceModal={replaceModal}
          />
        );
      }),
    [closeModal, currentModals]
  );

  if (modals.length) {
    return <div>{modals}</div>;
  }

  return null;
};

export default ModalRenderer;
